import { render, staticRenderFns } from "./NoRecordFound.vue?vue&type=template&id=126b8ba9&scoped=true"
import script from "./NoRecordFound.vue?vue&type=script&lang=js"
export * from "./NoRecordFound.vue?vue&type=script&lang=js"
import style0 from "./NoRecordFound.vue?vue&type=style&index=0&id=126b8ba9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126b8ba9",
  null
  
)

export default component.exports